import { clearSessionPreservingPrintSettings } from "../utils/orderPrintSettings";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { findCustomerByPhone, customerRequestOptions, normalizeCustomerPhoneToLocal, saveCustomerSale, completeCustomerSale } from "../services/customerService";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

function PromotionPage() {
  // State
  const [storeId, setStoreId] = useState(() => {
    const savedStoreId = localStorage.getItem("IDCH");
    return savedStoreId ? parseInt(savedStoreId, 10) : 1111; // Có thể cho chọn storeId nếu cần
  });
  const [promotions, setPromotions] = useState([]);
  const [selectedPromotion, setSelectedPromotion] = useState(null);
  const [selectedPromotionObj, setSelectedPromotionObj] = useState(null);
  const [promotionProducts, setPromotionProducts] = useState([]); // sẽ là mảng sản phẩm
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [giftProducts, setGiftProducts] = useState([]);
  const [rawGiftDetails, setRawGiftDetails] = useState([]); // To store original gift item details
  const [orderItems, setOrderItems] = useState([]);
  const [stockMap, setStockMap] = useState({});
  const [loading, setLoading] = useState({
    promotions: false,
    products: false,
    stock: false,
  });
  const [maPB, setMaPB] = useState(() => {
    const savedMaPB = localStorage.getItem("MaPB");
    return savedMaPB ? parseInt(savedMaPB, 10) : 119; // mapping với storeId nếu cần
  });
  const [dateStr, setDateStr] = useState(() => {
    const d = new Date();
    return d.toISOString().slice(0, 10);
  });
  const [expandedProductId, setExpandedProductId] = useState(null);
  const [selectedGift, setSelectedGift] = useState(null);

  // Thêm state cho khách hàng
  const [customerPhone, setCustomerPhone] = useState("");
  const [customerInfo, setCustomerInfo] = useState(null);
  const [showNewCustomerForm, setShowNewCustomerForm] = useState(false);
  const [newCustomerName, setNewCustomerName] = useState("");
  const [newCustomerAddress, setNewCustomerAddress] = useState("");
  const [newCustomerTaxCode, setNewCustomerTaxCode] = useState("");
  const [customerLoading, setCustomerLoading] = useState(false);
  const [stores, setStores] = useState([]); // Danh sách cửa hàng cho admin
  const [isAdmin, setIsAdmin] = useState(() =>
    localStorage.getItem("isAdmin") === "1" && localStorage.getItem("TenUser") === "admin"
  );

  // State cho toggle disable print API
  const [isDisablePrintAPI, setIsDisablePrintAPI] = useState(() => {
    const IDCH = localStorage.getItem("IDCH");
    // Mặc định bật (true) cho các cửa hàng khác 145 và 1000
    return IDCH !== "145" && IDCH !== "1000";
  });

  // State cho toggle in hóa đơn
  const [isPrintEnabled, setIsPrintEnabled] = useState(false);

  // State for side menu
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigate = useNavigate();

  // Kiểm tra trạng thái đăng nhập
  useEffect(() => {
    if (!localStorage.getItem("TenUser")) {
      navigate("/order/login");
    }
  }, [navigate]);

  // Khi là admin, lấy danh sách cửa hàng
  useEffect(() => {
    if (isAdmin) {
      axios.get("https://doticom.vn:3000/stores")
        .then(res => {
          setStores(res.data || []);
          // Nếu chưa chọn cửa hàng nào, chọn mặc định là cửa hàng đầu tiên
          if (!localStorage.getItem("IDCH") && res.data && res.data.length > 0) {
            const store = res.data[0];
            setStoreId(store.IDCH);
            setMaPB(store.MaPB);
            // Lưu thông tin cửa hàng vào localStorage
            localStorage.setItem("IDCH", store.IDCH);
            localStorage.setItem("MaPB", store.MaPB);
            localStorage.setItem("TenCuaHang", store.TenCuaHang);
            localStorage.setItem("IpBep", typeof store.IpBep === "string" ? store.IpBep.trim() : "");
            localStorage.setItem("IpMayTinh", typeof store.IpMayTinh === "string" ? store.IpMayTinh.trim() : "");
            localStorage.setItem("IpBanhNgot", typeof store.IpBanhNgot === "string" ? store.IpBanhNgot.trim() : "");
            localStorage.setItem("IpThuNgan", typeof store.IpThuNgan === "string" ? store.IpThuNgan.trim() : "");
            localStorage.setItem("LamTron", typeof store.LamTron === "string" ? store.LamTron.trim() : "0");
          }
        })
        .catch(() => setStores([]));
    }
  }, [isAdmin]);

  // Khi admin chọn cửa hàng mới
  const handleStoreChange = (e) => {
    const id = e.target.value;
    const store = stores.find(s => String(s.IDCH) === String(id));
    if (store) {
      setStoreId(store.IDCH);
      setMaPB(store.MaPB);
      // Lưu thông tin cửa hàng vào localStorage
      localStorage.setItem("IDCH", store.IDCH);
      localStorage.setItem("MaPB", store.MaPB);
      localStorage.setItem("TenCuaHang", store.TenCuaHang);
      localStorage.setItem("IpBep", typeof store.IpBep === "string" ? store.IpBep.trim() : "");
      localStorage.setItem("IpMayTinh", typeof store.IpMayTinh === "string" ? store.IpMayTinh.trim() : "");
      localStorage.setItem("IpBanhNgot", typeof store.IpBanhNgot === "string" ? store.IpBanhNgot.trim() : "");
      localStorage.setItem("IpThuNgan", typeof store.IpThuNgan === "string" ? store.IpThuNgan.trim() : "");
      localStorage.setItem("LamTron", typeof store.LamTron === "string" ? store.LamTron.trim() : "0");
    }
  };

  // Lấy danh sách ưu đãi
  useEffect(() => {
    async function fetchPromotions() {
      setLoading((l) => ({ ...l, promotions: true }));
      try {
        // Bảo vệ: chỉ gọi API admin nếu đúng cờ isAdmin
        let apiUrl;
        if (isAdmin) {
          apiUrl = `https://doticom.vn:3000/admin/promotions/${storeId}`;
        } else {
          apiUrl = `https://doticom.vn:3000/promotions/${storeId}`;
        }
        const res = await axios.get(apiUrl);
        setPromotions(res.data || []);
        if (res.data && res.data.length > 0) {
          // Auto-select first promotion and fetch its details
          handleSelectPromotion(res.data[0].MaUD);
        } else {
          setSelectedPromotion(null);
          setSelectedPromotionObj(null);
          setPromotionProducts([]);
          setGiftProducts([]);
          setRawGiftDetails([]);
        }
      } catch (err) {
        setPromotions([]);
        setPromotionProducts([]);
        setSelectedPromotionObj(null);
        setRawGiftDetails([]); // Clear on error
      } finally {
        setLoading((l) => ({ ...l, promotions: false }));
      }
    }
    fetchPromotions();
  }, [storeId, isAdmin]);

  // Khi chọn chương trình khuyến mãi
  const handleSelectPromotion = async (promotionId) => {
    setSelectedPromotion(promotionId);
    const promo = promotions.find((p) => p.MaUD === promotionId);
    setSelectedPromotionObj(promo || null);
    setPromotionProducts(promo?.items || []);
    setSelectedProduct(null);
    setGiftProducts([]);
    setRawGiftDetails([]); // Clear previous raw gift details
    setExpandedProductId(null);

    if (!promo) {
      setLoading((l) => ({ ...l, stock: false, products: false }));
      return;
    }

    setLoading((l) => ({ ...l, stock: true, products: true }));
    try {
      const [stockRes, giftRes] = await Promise.all([
        axios.get(
          `https://doticom.vn:3000/api/banhKMTonKho?MaPB=${maPB}&date=${dateStr}`
        ),
        // Only fetch promotion details if not MXTY=3 (where gifts come from promotionProducts)
        promo?.MXTY !== 3
          ? axios.get(
            `https://doticom.vn:3000/promotion-details/${promotionId}`
          )
          : Promise.resolve({ data: [] }),
      ]);
      // Map tồn kho
      const map = {};
      (stockRes.data || []).forEach((item) => {
        map[item.MaSP] = item.SoLuongConLai;
      });
      setStockMap(map);

      // Xử lý danh sách sản phẩm tặng kèm
      let gifts = [];
      const rawGiftsData = giftRes.data || [];
      if (promo?.MXTY !== 3) {
        // For MXTY=1 and others that use /promotion-details
        setRawGiftDetails(rawGiftsData); // Store raw gift details for original price
      }

      if (promo?.MXTY === 2) {
        // Lấy từ items của từng phần tử trong mảng trả về
        rawGiftsData.forEach((detail) => {
          if (Array.isArray(detail.items)) {
            gifts.push(...detail.items);
          }
        });
        // Đảm bảo không trùng mã sản phẩm
        gifts = gifts.filter(
          (item, idx, arr) => arr.findIndex((i) => i.MaSP === item.MaSP) === idx
        );
        // Gắn DonGia = 0 và isGift (DonGia in giftProducts state will be 0 for these)
        gifts = gifts.map((item) => ({
          ...item,
          isGift: true,
        }));
      } else if (promo?.MXTY !== 3) {
        // For other MXTY types using /promotion-details
        // MXTY khác 1 và khác 3, lấy toàn bộ danh sách trả về
        gifts = rawGiftsData.map((item) => ({
          ...item,
          isGift: true,
        }));
      }
      // For MXTY=3, giftProducts will be set by handleExpandProduct from promotionProducts
      // and those items will retain their original DonGia in giftProducts state.
      setGiftProducts(gifts);
    } catch (err) {
      setStockMap({});
      setGiftProducts([]);
      setRawGiftDetails([]);
    } finally {
      setLoading((l) => ({ ...l, stock: false, products: false }));
    }
  };

  // Khi chọn sản phẩm khuyến mãi
  const handleSelectPromotionOld = (promotionId) => {
    setSelectedPromotion(promotionId);
    const promo = promotions.find((p) => p.MaUD === promotionId);
    setSelectedPromotionObj(promo || null);
    setPromotionProducts(promo?.items || []);
    setSelectedProduct(null);
    setGiftProducts([]);
    setExpandedProductId(null);
  };

  // Lấy tồn kho cho tất cả sản phẩm khuyến mãi
  useEffect(() => {
    if (!maPB || !dateStr) return;
    async function fetchStock() {
      setLoading((l) => ({ ...l, stock: true }));
      try {
        const res = await axios.get(
          `https://doticom.vn:3000/api/banhKMTonKho?MaPB=${maPB}&date=${dateStr}`
        );
        // Map: MaSP => SoLuongConLai
        const map = {};
        (res.data || []).forEach((item) => {
          map[item.MaSP] = item.SoLuongConLai;
        });
        setStockMap(map);
      } catch (err) {
        setStockMap({});
      } finally {
        setLoading((l) => ({ ...l, stock: false }));
      }
    }
    fetchStock();
  }, [maPB, dateStr, promotionProducts]);

  // Thêm sản phẩm vào giỏ hàng
  const handleAddToOrder = (product) => {
    const stock = stockMap[product.MaSP] ?? 9999;
    if (stock <= 0) {
      alert("Sản phẩm đã hết hàng hoặc vượt quá tồn kho!");
      return;
    }
    const exist = orderItems.find(
      (i) => i.MaSP === product.MaSP && i.DonGia === product.DonGia
    );
    if (exist) {
      setOrderItems(
        orderItems.map((i) =>
          i.MaSP === product.MaSP && i.DonGia === product.DonGia
            ? { ...i, quantity: i.quantity + 1 }
            : i
        )
      );
    } else {
      setOrderItems([...orderItems, { ...product, quantity: 1 }]);
    }
    setStockMap((prev) => ({
      ...prev,
      [product.MaSP]: stock - 1,
    }));
  };

  // Xóa sản phẩm khỏi giỏ hàng
  const handleRemoveFromOrder = (maSP) => {
    const exist = orderItems.find((i) => i.MaSP === maSP && i.DonGia !== 0);
    if (!exist) return;

    // Nếu là sản phẩm khuyến mãi, kiểm tra có gift liên quan không
    const relatedGift = orderItems
      .filter((i) => i.DonGia === 0 && i.selectedMainSP === maSP)
      .sort((a, b) => b.quantity - a.quantity)[0]; // lấy gift có quantity lớn nhất (ưu tiên giảm gift nào còn nhiều)

    if (exist.quantity > 1) {
      // Giảm sản phẩm chính
      setOrderItems((prev) =>
        prev.map((i) =>
          i.MaSP === maSP && i.DonGia !== 0
            ? { ...i, quantity: i.quantity - 1 }
            : i
        )
      );
      // Tăng tồn kho sản phẩm chính
      setStockMap((prev) => ({
        ...prev,
        [maSP]: (prev[maSP] ?? 0) + 1,
      }));
      // Nếu có gift liên quan thì giảm 1 gift và tăng tồn kho gift đúng 1 lần
      if (relatedGift) {
        setOrderItems((prev) =>
          prev
            .map((i) =>
              i.MaSP === relatedGift.MaSP &&
                i.DonGia === 0 &&
                i.selectedMainSP === maSP
                ? { ...i, quantity: i.quantity - 1 }
                : i
            )
            .filter((i) => i.quantity > 0)
        );
        setStockMap((prev) => ({
          ...prev,
          [relatedGift.MaSP]: (prev[relatedGift.MaSP] ?? 0) + 1,
        }));
      }
    } else {
      // Xóa hoàn toàn sản phẩm chính và tất cả gift liên quan
      setOrderItems((prev) =>
        prev.filter(
          (i) =>
            !(i.MaSP === maSP && i.DonGia !== 0) &&
            !(i.DonGia === 0 && i.selectedMainSP === maSP)
        )
      );
      // Tăng tồn kho sản phẩm chính
      setStockMap((prev) => ({
        ...prev,
        [maSP]: (prev[maSP] ?? 0) + 1,
      }));
      // Tăng tồn kho cho tất cả gift liên quan đúng số lượng đã chọn
      if (relatedGift) {
        orderItems
          .filter((i) => i.DonGia === 0 && i.selectedMainSP === maSP)
          .forEach((giftItem) => {
            setStockMap((prev2) => ({
              ...prev2,
              [giftItem.MaSP]: (prev2[giftItem.MaSP] ?? 0) + giftItem.quantity,
            }));
          });
      }
    }
  };

  // Kiểm tra đã thêm sản phẩm khuyến mãi vào giỏ chưa
  // Đếm số lượng từng sản phẩm khuyến mãi trong giỏ
  const mainProductCountInCart = selectedProduct
    ? orderItems
      .filter(
        (i) =>
          i.MaSP === selectedProduct.MaSP &&
          i.DonGia === selectedProduct.DonGia
      )
      .reduce((sum, i) => sum + i.quantity, 0)
    : 0;

  // Đếm số lượng sản phẩm tặng kèm đã chọn ứng với sản phẩm khuyến mãi này
  const giftCountForMainProduct = selectedProduct
    ? orderItems
      .filter(
        (i) => i.DonGia === 0 && i.selectedMainSP === selectedProduct.MaSP // custom field, see below
      )
      .reduce((sum, i) => sum + i.quantity, 0)
    : 0;

  // Thêm sản phẩm tặng kèm vào giỏ khi click vào card
  const handleGiftClick = (gift) => {
    const stock = stockMap[gift.MaSP] ?? 9999;
    if (stock <= 0) {
      alert("Sản phẩm tặng kèm đã hết hàng hoặc vượt quá tồn kho!");
      return;
    }
    if (
      !selectedProduct ||
      mainProductCountInCart === 0 ||
      giftCountForMainProduct >= mainProductCountInCart
    )
      return;

    let originalPriceOfGift;
    if (selectedPromotionObj?.MXTY === 3) {
      // For MXTY=3, 'gift' comes from promotionProducts and gift.DonGia is original.
      originalPriceOfGift = gift.DonGia;
    } else {
      // For MXTY=1 and others, 'gift' comes from giftProducts where DonGia was set to 0.
      // Find original price from rawGiftDetails.
      const rawDetail = rawGiftDetails.find((rgd) => rgd.MaSP === gift.MaSP);
      originalPriceOfGift = rawDetail ? rawDetail.DonGia : gift.DonGia || 0; // Fallback to gift.DonGia if rawDetail not found
    }

    const existIndex = orderItems.findIndex(
      (i) =>
        i.MaSP === gift.MaSP &&
        i.DonGia === 0 &&
        i.selectedMainSP === selectedProduct.MaSP
    );
    if (existIndex > -1) {
      const updatedItems = [...orderItems];
      updatedItems[existIndex] = {
        ...updatedItems[existIndex],
        quantity: updatedItems[existIndex].quantity + 1,
      };
      setOrderItems(updatedItems);
    } else {
      setOrderItems([
        ...orderItems,
        {
          ...gift,
          quantity: 1,
          DonGia: 0, // Actual price in cart is 0 for gift
          originalPrice: originalPriceOfGift,
          selectedMainSP: selectedProduct.MaSP,
          isGiftItem: true, // Flag as gift item
        },
      ]);
    }
    // Giảm tồn kho hiển thị cho sản phẩm tặng kèm
    setStockMap((prev) => ({
      ...prev,
      [gift.MaSP]: stock - 1,
    }));
  };

  // Thêm sản phẩm tặng kèm vào giỏ (tăng số lượng)
  const handleAddGiftFromOrder = (gift) => {
    const stock = stockMap[gift.MaSP] ?? 9999;
    if (stock <= 0) {
      alert("Sản phẩm tặng kèm đã hết hàng hoặc vượt quá tồn kho!");
      return;
    }
    // originalPrice and isGiftItem flags should already exist on the 'gift' object from orderItems
    setOrderItems(
      orderItems.map((i) =>
        i.MaSP === gift.MaSP &&
          i.DonGia === 0 &&
          i.selectedMainSP === gift.selectedMainSP
          ? { ...i, quantity: i.quantity + 1 }
          : i
      )
    );
    // Giảm tồn kho hiển thị cho sản phẩm tặng kèm
    setStockMap((prev) => ({
      ...prev,
      [gift.MaSP]: stock - 1,
    }));
  };

  // Giảm sản phẩm tặng kèm trong giỏ (giảm số lượng hoặc xóa)
  const handleRemoveGiftFromOrder = (gift) => {
    setOrderItems((prev) => {
      const idx = prev.findIndex(
        (i) =>
          i.MaSP === gift.MaSP &&
          i.DonGia === 0 &&
          i.selectedMainSP === gift.selectedMainSP
      );
      if (idx === -1) return prev;
      const newItems = [...prev];
      if (newItems[idx].quantity > 1) {
        newItems[idx] = {
          ...newItems[idx],
          quantity: newItems[idx].quantity - 1,
        };
      } else {
        newItems.splice(idx, 1);
      }
      return newItems;
    });
    // Tăng tồn kho hiển thị cho sản phẩm tặng kèm
    setStockMap((prev) => ({
      ...prev,
      [gift.MaSP]: (prev[gift.MaSP] ?? 0) + 1,
    }));

  };

  // Lấy danh sách sản phẩm tặng kèm khi click vào sản phẩm ưu đãi
  const handleExpandProduct = (product) => {
    setExpandedProductId(product.MaSP);
    setSelectedProduct(product);
    setSelectedGift(null);

    // Không đóng danh sách tặng kèm khi click lại, luôn mở cho sản phẩm được chọn
    let currentGiftList = [];
    if (selectedPromotionObj && selectedPromotionObj.MXTY === 3) {
      // Tặng kèm là bất kỳ bánh nào trong danh sách, giá <= giá sản phẩm khuyến mãi
      // These items from promotionProducts have their original DonGia.
      currentGiftList = (promotionProducts || [])
        .filter(
          (g) =>
            g.DonGia <= product.DonGia &&
            (stockMap[g.MaSP] === undefined || stockMap[g.MaSP] > 0)
        )
        .map((g) => ({ ...g, isGift: true })); // Mark as potential gift
    } else if (selectedPromotionObj) {
      // For MXTY=1 and others
      // giftProducts state was populated from rawGiftDetails with DonGia=0.
      // Filter this list by stock.
      currentGiftList = giftProducts.filter(
        (gift) => stockMap[gift.MaSP] === undefined || stockMap[gift.MaSP] > 0
      );
    }
    setGiftProducts(currentGiftList);
  };

  // Tổng tiền
  const subtotal = orderItems.reduce(
    (sum, i) => sum + i.DonGia * i.quantity,
    0
  );

  // Thanh toán
  const handleCheckout = async () => {
    if (orderItems.length === 0) {
      alert("Vui lòng chọn sản phẩm!");
      return;
    }

    const totalAmount = subtotal;
    const storedCustomerInfo = customerInfo;

    const apiItems = orderItems.map((item) => {
      const itemName =
        item.Ten_SP ||
        item.TenSP ||
        (item.isGiftItem ? "Sản phẩm tặng" : "Sản phẩm KM");
      const itemUnit = item.DVT_SP ? ` (${item.DVT_SP})` : "";
      const displayName = `${itemName}${itemUnit}`;

      if (item.isGiftItem || (item.DonGia === 0 && item.selectedMainSP)) {
        // Is a gift item
        return {
          id: item.MaSP,
          name: displayName,
          quantity: item.quantity,
          unitPrice: item.originalPrice !== undefined ? item.originalPrice : 0, // Original price of the gift
          KmaiPT: 100, // 100% discount for gift
          ThanhTien: 0, // Total price for gift is 0
          MXTY: selectedPromotionObj?.MXTY || 0, // MXTY from the selected promotion
          note: "Hàng tặng KM",
        };
      } else {
        // Is a main promotional item
        return {
          id: item.MaSP,
          name: displayName,
          quantity: item.quantity,
          unitPrice: item.DonGia, // Price at which it's sold
          KmaiPT: 0, // Assuming DonGia is already the promotional price
          ThanhTien: item.DonGia * item.quantity,
          MXTY: 0, // Main items do not carry the promotion's MXTY as per request
          note: "",
        };
      }
    });

    const billDetails = {
      storeId: storeId,
      totalAmount: totalAmount,
      cashGiven: totalAmount,
      change: 0,
      MaTheVIP: storedCustomerInfo?.MaKH || "",
      MaKH: storedCustomerInfo?.MaKH || "",
      HeSoTichDiem: 0.02,
      TieuDiem: 0,
      GiamPT: 0,
      GiamTienMat: 0,
      GiamTMTheVIP: 0,
      employeeName: localStorage.getItem('MaNV'),
      TenKH: storedCustomerInfo?.Ten || storedCustomerInfo?.TenKH || "Khách lẻ",
      items: apiItems,
    };

    const body = {
      billDetails,
      puller: 1,
    };

    try {
      // Save to database
      const saveDBResponse = await saveCustomerSale("https://doticom.vn:3000", body);

      // Sau khi lưu DB thành công, gọi API in hóa đơn
      const printOrderId = `HD${Date.now()}`;
      const printItems = orderItems.map((item) => {
        const baseName =
          item.Ten_SP ||
          item.TenSP ||
          (item.isGiftItem ? "Sản phẩm tặng" : "Sản phẩm KM");
        const unitName = item.DVT_SP ? ` (${item.DVT_SP})` : "";
        const formattedName = `${baseName}${unitName}`;

        let itemPriceForPrint;
        let itemCategoryForPrint;

        if (item.isGiftItem || (item.DonGia === 0 && item.selectedMainSP)) {
          // Is a gift item
          itemPriceForPrint =
            item.originalPrice !== undefined ? item.originalPrice : 0;
          itemCategoryForPrint = "Hàng tặng KM";
        } else {
          // Is a main promotional item
          itemPriceForPrint = item.DonGia;
          itemCategoryForPrint = selectedPromotionObj?.TenUD || "Sản phẩm KM";
        }

        return {
          id: item.MaSP,
          name: formattedName,
          quantity: item.quantity,
          unitPrice: itemPriceForPrint,
          note: item.note || "",
          isQR: false,
          Sale_OrderMR: "",
          ThanhTien: item.DonGia * item.quantity,
          category: itemCategoryForPrint,
          MaSP: item.MaSP,
          VAT_SP: item.VAT_SP || 0,
          KmaiPT: item.isGiftItem || (item.DonGia === 0 && item.selectedMainSP) ? 100 : 0,
        };
      });

      // Build billDetails for print with all required fields
      const printBillDetails = {
        storeId: String(storeId),
        totalAmount: totalAmount,
        cashGiven: 0,
        change: 0,
        MaTheVIP: storedCustomerInfo?.MaKH || "",
        GiamPT: 0,
        GiamTienMat: 0,
        GiamTMTheVIP: 0,
        employeeName: localStorage.getItem('MaNV') || "",
        TenKH: storedCustomerInfo?.Ten || storedCustomerInfo?.TenKH || "Khách lẻ",
        MaKH: storedCustomerInfo?.MaKH || "",
        loyalty: saveDBResponse.data.loyalty,
        IDXuat: saveDBResponse.data.IDXuat,
        ipBanhNgot: localStorage.getItem('IpBanhNgot') || "",
        HeSoTichDiem: "0.02",
        TieuDiem: 0,
        PhuongThucThanhToan: "1.1",
        GhiChu: "Khuyến mãi",
        items: printItems,
      };

      const printBody = {
        billDetails: printBillDetails,
        orderId: printOrderId,
        cashier: localStorage.getItem('TenNV') || "",
        items: printItems,
        storeName: localStorage.getItem('TenCuaHang') || "",
        ipThuNgan: localStorage.getItem('IpMayTinh') || "",
        ipBep: localStorage.getItem('IpBep') || "",
        pull: "1",
      };

      try {
        const IpMayTinh = localStorage.getItem('IpMayTinh');
        // Chỉ gọi API print nếu isDisablePrintAPI = false
        if (!isDisablePrintAPI) {
          await axios.post(`https://${IpMayTinh}/print`, printBody, {
            headers: {
              "Content-Type": "application/json",
            },
          });
        }
      } catch (err) {
        // Không alert khi in lỗi, chỉ log
        console.error(
          "Lỗi khi gọi API in hóa đơn:",
          err.response || err.message || err
        );
      }

      // --- In bill bằng máy in USB qua window.print ---
      if (isPrintEnabled) {
        console.log("Print enabled, generating bill HTML...");
        const TenCuaHang = localStorage.getItem('TenCuaHang') || 'Cửa hàng';
        const TenNV = localStorage.getItem('TenNV') || 'Thu ngân';

        // Calculate loyalty points
        const diemTichLuyMoi = saveDBResponse.data.loyalty?.DiemConlai ?? "Chưa xác nhận";

        const billHtml = `
  <html>
    <head>
      <title>Hóa đơn khuyến mãi</title>
      <style>
        body { font-family: Arial, sans-serif; font-size: 16px; }
        h2 { text-align: center; }
        .stt {text-align: start;}
        table { width: 100%; border-collapse: collapse; margin-top: 10px; }
        th, td { border: 1px solid #ccc; padding: 4px 8px; text-align: left; }
        .total { font-weight: bold; font-size: 18px; }
        @media print {
          body { margin: 0; }
        }
      </style>
    </head>
    <body>
      <h2>${TenCuaHang}</h2>
      <div>Ngày: ${new Date().toLocaleString()}</div>
      <div>Thu ngân: ${TenNV}</div>
      <h2 class="stt">HÓA ĐƠN KHUYẾN MÃI</h2>
      <hr/>
      <div>
        <b>Khách hàng:</b> ${storedCustomerInfo?.TenKH || storedCustomerInfo?.Ten || "Khách lẻ"}<br/>
        ${storedCustomerInfo?.TenKH || storedCustomerInfo?.Ten ? `
          <b>SĐT:</b> ${storedCustomerInfo?.SDT || storedCustomerInfo?.Sdt || ""}<br/>
          <b>Điểm tích lũy:</b> ${diemTichLuyMoi.toLocaleString()}
        ` : ""}
      </div>
      <hr/>
      <table>
        <thead>
          <tr>
            <th>Sản phẩm</th>
            <th>SL</th>
            <th>Đơn giá</th>
            <th>Thành tiền</th>
          </tr>
        </thead>
        <tbody>
          ${orderItems.map(item => `
            <tr>
              <td>${item.Ten_SP || item.TenSP}${item.isGiftItem ? ' (Tặng)' : ''}</td>
              <td>${item.quantity}</td>
              <td>${(item.originalPrice !== undefined ? item.originalPrice : item.DonGia).toLocaleString()}</td>
              <td>${(item.DonGia * item.quantity).toLocaleString()}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
      <hr/>
      <div>Tạm tính: ${subtotal.toLocaleString()}₫</div>
      <div class="total">Thành tiền: ${totalAmount.toLocaleString()}₫</div>
      <hr/>
      <div>Cảm ơn quý khách!</div>
      <div style="margin-top: 4px; font-weight: 500; color: #000; font-size: 14px;">
        Chương trình khuyến mãi: ${selectedPromotionObj?.TenUD || ''}
      </div>
      <script>
        window.onload = function() {
          console.log("Print window loaded, triggering print...");
          window.print();
          setTimeout(function() { 
            console.log("Closing print window...");
            window.close(); 
          }, 500);
        };
      </script>
    </body>
  </html>
`;
        console.log("Opening print window...");
        const printWindow = window.open("", "_blank", "width=400,height=600");
        if (printWindow) {
          console.log("Print window opened successfully");
          printWindow.document.write(billHtml);
          printWindow.document.close();
          console.log("Bill HTML written to print window");
        } else {
          console.error("Failed to open print window - popup may be blocked");
          toast.error("Không thể mở cửa sổ in. Vui lòng kiểm tra popup blocker.");
        }
      } else {
        console.log("Print is disabled (isPrintEnabled is false)");
      }

      toast.success(
        `Thanh toán thành công! Tổng: ${totalAmount.toLocaleString()}₫`
      );
      setOrderItems([]);
      setSelectedProduct(null);
      setGiftProducts([]);
      // Xóa thông tin khách hàng sau khi thanh toán
      setCustomerInfo(null);
      setCustomerPhone("");
      setShowNewCustomerForm(false);
      localStorage.removeItem("currentCustomerInfo");
      completeCustomerSale(storeId);
      // Re-fetch stock for current promotion or clear it
      if (selectedPromotionObj) {
        handleSelectPromotion(selectedPromotionObj.MaUD); // This will re-fetch stock and gifts
      } else {
        setStockMap({});
      }
    } catch (err) {
      console.error("Lỗi khi lưu hóa đơn:", err.response || err.message || err);
      alert(
        "Có lỗi khi lưu hóa đơn: " +
        (err.response?.data?.message || err.message || "Unknown error")
      );
    } finally {
      // setLoading(false)
    }
  };

  // Xử lý nhập SĐT khách hàng
  const handlePhoneInputChange = (e) => {
    setCustomerPhone(e.target.value);
  };

  // Tìm kiếm khách hàng theo SĐT
  const handleSearchCustomer = async () => {
    if (!customerPhone.trim()) {
      toast.error("Vui lòng nhập số điện thoại.");
      return;
    }
    setCustomerLoading(true);
    setShowNewCustomerForm(false);
    setCustomerInfo(null);
    localStorage.removeItem("currentCustomerInfo");
    try {
      const foundCustomer = await findCustomerByPhone("https://doticom.vn:3000", customerPhone);
      if (foundCustomer) {
        setCustomerInfo(foundCustomer);
        localStorage.setItem("currentCustomerInfo", JSON.stringify(foundCustomer));
        toast.success(`Đã tìm thấy khách hàng: ${foundCustomer.TenKH}`);
      } else {
        toast.info("Không tìm thấy khách hàng. Bạn có thể thêm mới.");
        setShowNewCustomerForm(true);
      }
    } catch (error) {
      toast.error("Lỗi khi tìm kiếm khách hàng.");
    } finally {
      setCustomerLoading(false);
    }
  };

  // Tạo mới khách hàng
  const handleCreateNewCustomer = async (e) => {
    e.preventDefault();
    if (!newCustomerName.trim() || !customerPhone.trim()) {
      toast.error("Tên khách hàng và số điện thoại là bắt buộc.");
      return;
    }
    setCustomerLoading(true);
    try {
      const response = await axios.post(
        "https://doticom.vn:3000/customers/add",
        {
          Ten: newCustomerName,
          SDT: normalizeCustomerPhoneToLocal(customerPhone),
          DiaChi: newCustomerAddress,
          MST: newCustomerTaxCode,
          DiemTichLuy: 0,
        },
        customerRequestOptions(),
      );
      setCustomerInfo(response.data);
      localStorage.setItem("currentCustomerInfo", JSON.stringify(response.data));
      toast.success(`Đã thêm khách hàng mới: ${response.data.TenKH}`);
      setShowNewCustomerForm(false);
      setNewCustomerName("");
      setNewCustomerAddress("");
      setNewCustomerTaxCode("");
    } catch (error) {
      toast.error(
        "Lỗi khi tạo khách hàng mới: " +
        (error.response?.data?.message || error.message)
      );
    } finally {
      setCustomerLoading(false);
    }
  };

  // Logout handler
  const handleLogout = () => {
    clearSessionPreservingPrintSettings();
    window.location.reload();
  };

  // Handler for disable print API toggle
  const handleToggleDisablePrintAPI = () => {
    setIsDisablePrintAPI((prev) => !prev);
  };

  // Handler for print toggle
  const handleTogglePrint = () => {
    setIsPrintEnabled((prev) => !prev);
  };

  // Toggle side menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Close menu when clicking outside
  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <div
      className="container-fluid bg-light"
      style={{ padding: 0, minHeight: "100vh" }}
    >
      {/* Menu button ở góc trên bên phải */}
      <div style={{ position: "fixed", top: -2, right: 0, zIndex: 9999 }}>
        <button
          className="btn btn-outline-primary btn-sm"
          onClick={toggleMenu}
          title="Menu"
        >
          <i className="bi bi-list me-1"></i>Menu
        </button>
      </div>

      {/* Overlay */}
      {isMenuOpen && (
        <div
          className="position-fixed w-100 h-100"
          style={{
            top: 0,
            left: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 10000,
          }}
          onClick={closeMenu}
        />
      )}

      {/* Side Menu */}
      <div
        className={`position-fixed h-100 bg-white shadow-lg ${isMenuOpen ? "menu-open" : "menu-closed"
          }`}
        style={{
          top: 0,
          right: 0,
          width: "300px",
          zIndex: 10001,
          transition: "transform 0.3s ease-in-out",
          transform: isMenuOpen ? "translateX(0)" : "translateX(100%)",
          borderLeft: "1px solid #dee2e6",
        }}
      >
        <div className="p-3 h-100 d-flex flex-column">
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-3 pb-3 border-bottom">
            <h5 className="mb-0">
              <i className="bi bi-gear me-2"></i>Cài đặt
            </h5>
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={closeMenu}
              title="Đóng"
            >
              <i className="bi bi-x-lg"></i>
            </button>
          </div>

          {/* Menu Content */}
          <div className="flex-grow-1">
            {/* Print Settings */}
            <div className="mb-4">
              <h6 className="text-muted mb-3">
                <i className="bi bi-printer me-2"></i>Cài đặt in ấn
              </h6>

              <div className="form-check mb-3">
                <input
                  type="checkbox"
                  id="printToggle"
                  checked={isPrintEnabled}
                  onChange={handleTogglePrint}
                  className="form-check-input"
                />
                <label htmlFor="printToggle" className="form-check-label">
                  In hóa đơn (USB)
                </label>
              </div>

              <div className="form-check mb-3">
                <input
                  type="checkbox"
                  id="disablePrintAPIToggle"
                  checked={isDisablePrintAPI}
                  onChange={handleToggleDisablePrintAPI}
                  className="form-check-input"
                />
                <label htmlFor="disablePrintAPIToggle" className="form-check-label">
                  Tắt API in mạng
                </label>
              </div>
            </div>

            {/* Store Info (if admin) */}
            {isAdmin && (
              <div className="mb-4">
                <h6 className="text-muted mb-3">
                  <i className="bi bi-shop me-2"></i>Thông tin cửa hàng
                </h6>
                <div className="mb-2">
                  <small className="text-muted">Cửa hàng hiện tại:</small>
                  <div className="fw-bold">{localStorage.getItem('TenCuaHang') || 'Chưa chọn'}</div>
                </div>
                <div className="mb-2">
                  <small className="text-muted">Mã cửa hàng:</small>
                  <div className="fw-bold">{storeId}</div>
                </div>
              </div>
            )}

            {/* User Info */}
            <div className="mb-4">
              <h6 className="text-muted mb-3">
                <i className="bi bi-person me-2"></i>Thông tin người dùng
              </h6>
              <div className="mb-2">
                <small className="text-muted">Tài khoản:</small>
                <div className="fw-bold">{localStorage.getItem('TenUser') || 'N/A'}</div>
              </div>
              <div className="mb-2">
                <small className="text-muted">Mã nhân viên:</small>
                <div className="fw-bold">{localStorage.getItem('MaNV') || 'N/A'}</div>
              </div>
            </div>
          </div>

          {/* Logout Button */}
          <div className="mt-auto pt-3 border-top">
            <button
              className="btn btn-danger w-100"
              onClick={handleLogout}
            >
              <i className="bi bi-box-arrow-right me-2"></i>Đăng xuất
            </button>
          </div>
        </div>
      </div>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <div className="row g-0" style={{ height: "100vh" }}>
        {/* PHẦN 1: Ưu đãi + Sản phẩm khuyến mãi + Sản phẩm tặng kèm */}
        <div
          className="col-12 col-lg-8 d-flex flex-column"
          style={{
            height: "100vh",
            minWidth: 400,
            padding: 10,
            borderRadius: "10px",
            overflow: "hidden",
          }}
        >
          {/* Nếu là admin, hiển thị bảng chọn cửa hàng */}
          {isAdmin && (
            <div className="mb-2">
              <label htmlFor="storeSelect" className="form-label fw-bold">
                Chọn cửa hàng:
              </label>
              <select
                id="storeSelect"
                className="form-select"
                style={{ maxWidth: 400, display: "inline-block" }}
                value={storeId}
                onChange={handleStoreChange}
              >
                {stores.map((store) => (
                  <option key={store.IDCH} value={store.IDCH}>
                    {store.TenCuaHang} (ID: {store.IDCH})
                  </option>
                ))}
              </select>
            </div>
          )}
          {/* Ưu đãi nằm ngang, cuộn ngang nếu nhiều */}
          <div
            className="py-2 px-2"
            style={{
              background: "#e7f1ff",
              borderTop: "2px solid rgb(253, 141, 13)",
              borderRadius: "2px solid rgb(253, 141, 13)",
              borderRight: "2px solid rgb(253, 141, 13)",
              borderLeft: "2px solid rgb(253, 141, 13)",
              borderBottom: "2px solid rgb(39, 22, 197)",
            }}
          >
            <div className="overflow-auto" style={{ whiteSpace: "nowrap" }}>
              {loading.promotions ? (
                <span className="text-secondary ms-2">
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Đang tải ưu đãi...
                </span>
              ) : promotions.length === 0 ? (
                <span className="alert alert-warning py-1 px-2 mb-0">
                  Không có ưu đãi nào
                </span>
              ) : (
                <div className="d-inline-flex gap-2">
                  {promotions.map((promo) => (
                    <button
                      key={promo.MaUD}
                      className={`btn btn-outline-primary text-start ${selectedPromotion === promo.MaUD
                          ? "active fw-bold border-2"
                          : ""
                        }`}
                      style={{
                        borderRadius: 10,
                        borderWidth: selectedPromotion === promo.MaUD ? 2 : 1,
                        background:
                          selectedPromotion === promo.MaUD ? "#e7f1ff" : "#fff",
                        boxShadow:
                          selectedPromotion === promo.MaUD
                            ? "0 0 6px #0d6efd33"
                            : "",
                        minWidth: 180,
                        marginRight: 8,
                      }}
                      onClick={() => handleSelectPromotion(promo.MaUD)}
                    >
                      <div>{promo.TenUD || promo.TenUDCT || promo.MaUD}</div>
                      <div style={{ fontSize: 12, color: "#888" }}>
                        {promo.NgayBatDau?.slice(0, 10)} -{" "}
                        {promo.NgayKetThuc?.slice(0, 10)}
                      </div>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
          {/* 2 bảng sản phẩm khuyến mãi và tặng kèm */}
          <div
            className="flex-grow-1 d-flex flex-column flex-md-row gap-0"
            style={{
              overflow: "hidden",
              borderLeft: "2px solid rgb(253, 141, 13)",
              borderRight: "2px solid rgb(253, 141, 13)",
              borderBottom: "2px solid rgb(253, 141, 13)",
            }}
          >
            {/* Sản phẩm khuyến mãi */}
            <div
              className="flex-grow-1 border-end bg-white shadow-sm d-flex flex-column"
              style={{ minWidth: 0, width: "50%" }}
            >
              <div
                className="text-center py-2"
                style={{
                  background: "#eafaf1",
                  borderBottom: "2px solid #198754",
                }}
              >
                <h5 className="mb-0 text-success">
                  <i className="bi bi-bag-heart-fill me-2"></i>Sản phẩm khuyến
                  mãi
                </h5>
              </div>
              <div className="flex-grow-1 overflow-auto px-2 pt-2">
                {loading.products ? (
                  <div className="text-center text-secondary py-4">
                    <div className="spinner-border spinner-border-sm me-2"></div>
                    Đang tải sản phẩm...
                  </div>
                ) : promotionProducts.length === 0 ? (
                  <div className="alert alert-warning text-center mt-3">
                    Không có sản phẩm khuyến mãi
                  </div>
                ) : selectedPromotionObj?.MXTY === 2 ? (
                  // For MXTY = 2, group products by Hambuger vs others
                  (() => {
                    const hambugerProducts = promotionProducts.filter(product => {
                      const name = (product.Ten_SP || product.TenSP || "").toLowerCase();
                      return /^(hambuger|hamburger)/.test(name);
                    });

                    const otherProducts = promotionProducts.filter(product => {
                      const name = (product.Ten_SP || product.TenSP || "").toLowerCase();
                      return !(/^(hambuger|hamburger)/.test(name));
                    });

                    const sortProductsByStock = (products) =>
                      [...products].sort((a, b) => {
                        const stockA = stockMap[a.MaSP] ?? 1;
                        const stockB = stockMap[b.MaSP] ?? 1;
                        if ((stockA > 0 ? 0 : 1) !== (stockB > 0 ? 0 : 1)) {
                          return (stockA > 0 ? 0 : 1) - (stockB > 0 ? 0 : 1);
                        }
                        return 0;
                      });

                    const renderProductGroup = (products, groupColor = "") => (
                      <div className="row row-cols-2 row-cols-xl-4 g-2">
                        {sortProductsByStock(products).map((product) => {
                          const isOutOfStock = (stockMap[product.MaSP] ?? 1) <= 0;
                          return (
                            <div className="col" key={product.MaSP}>
                              <div
                                className={`card h-100 shadow-sm ${selectedProduct?.MaSP === product.MaSP
                                    ? "border-success border-2"
                                    : ""
                                  }`}
                                style={{
                                  cursor: isOutOfStock ? "not-allowed" : "pointer",
                                  opacity: isOutOfStock ? 0.5 : 1,
                                  transition: "box-shadow 0.2s",
                                  boxShadow: selectedProduct?.MaSP === product.MaSP
                                    ? "0 0 10px #19875433"
                                    : "",
                                  backgroundColor: groupColor,
                                }}
                                onClick={(e) => {
                                  if (isOutOfStock) return;
                                  setSelectedProduct(product);
                                  handleExpandProduct(product);
                                  handleAddToOrder(product);
                                }}
                              >
                                <div className="card-body d-flex flex-column justify-content-between p-2">
                                  <div>
                                    <b className="text-dark">
                                      {product.Ten_SP || product.TenSP}
                                    </b>
                                    <div style={{ fontSize: 13, color: "#888" }}>
                                      Giá:{" "}
                                      <span className="text-danger">
                                        {product.DonGia?.toLocaleString()}₫
                                      </span>
                                      {stockMap[product.MaSP] !== undefined && (
                                        <span
                                          style={{
                                            marginLeft: 10,
                                            color: stockMap[product.MaSP] > 0 ? "green" : "red",
                                          }}
                                        >
                                          <i className="bi bi-box-seam me-1"></i>
                                          Tồn: {stockMap[product.MaSP]}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    );

                    return (
                      <div>
                        {otherProducts.length > 0 && (
                          <div className="mb-3">
                            <div className="d-flex align-items-center mb-2">
                              <h6 className="mb-0 text-primary">
                                <i className="bi bi-bread-slice me-2"></i>Bánh mì & Sản phẩm khác
                              </h6>
                              <span className="badge bg-primary ms-2">{otherProducts.length}</span>
                            </div>
                            {renderProductGroup(otherProducts)}
                          </div>
                        )}

                        {hambugerProducts.length > 0 && (
                          <div>
                            <hr className="my-3" style={{ borderColor: "#fd8c00", borderWidth: "2px" }} />
                            <div className="d-flex align-items-center mb-2">
                              <h6 className="mb-0 text-warning">
                                <i className="bi bi-burger me-2"></i>Hambuger
                              </h6>
                              <span className="badge bg-warning text-dark ms-2">{hambugerProducts.length}</span>
                            </div>
                            {renderProductGroup(hambugerProducts, "#fff8e1")}
                          </div>
                        )}
                      </div>
                    );
                  })()
                ) : (
                  // For other MXTY types, use original layout
                  <div className="row row-cols-2 row-cols-xl-4 g-2">
                    {[...promotionProducts]
                      .sort((a, b) => {
                        const stockA = stockMap[a.MaSP] ?? 1;
                        const stockB = stockMap[b.MaSP] ?? 1;
                        if ((stockA > 0 ? 0 : 1) !== (stockB > 0 ? 0 : 1)) {
                          return (stockA > 0 ? 0 : 1) - (stockB > 0 ? 0 : 1);
                        }
                        return 0;
                      })
                      .map((product) => {
                        const isOutOfStock = (stockMap[product.MaSP] ?? 1) <= 0;
                        return (
                          <div className="col" key={product.MaSP}>
                            <div
                              className={`card h-100 shadow-sm ${selectedProduct?.MaSP === product.MaSP
                                  ? "border-success border-2"
                                  : ""
                                }`}
                              style={{
                                cursor: isOutOfStock
                                  ? "not-allowed"
                                  : "pointer",
                                opacity: isOutOfStock ? 0.5 : 1,
                                transition: "box-shadow 0.2s",
                                boxShadow:
                                  selectedProduct?.MaSP === product.MaSP
                                    ? "0 0 10px #19875433"
                                    : "",
                              }}
                              onClick={(e) => {
                                if (isOutOfStock) return;
                                setSelectedProduct(product);
                                handleExpandProduct(product);
                                handleAddToOrder(product);
                              }}
                            >
                              <div className="card-body d-flex flex-column justify-content-between p-2">
                                <div>
                                  <b className="text-dark">
                                    {product.Ten_SP || product.TenSP}
                                  </b>
                                  <div style={{ fontSize: 13, color: "#888" }}>
                                    Giá:{" "}
                                    <span className="text-danger">
                                      {product.DonGia?.toLocaleString()}₫
                                    </span>
                                    {stockMap[product.MaSP] !== undefined && (
                                      <span
                                        style={{
                                          marginLeft: 10,
                                          color:
                                            stockMap[product.MaSP] > 0
                                              ? "green"
                                              : "red",
                                        }}
                                      >
                                        <i className="bi bi-box-seam me-1"></i>
                                        Tồn: {stockMap[product.MaSP]}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                )}
              </div>
            </div>
            {/* Sản phẩm tặng kèm */}
            <div
              className="flex-grow-1 bg-white shadow-sm d-flex flex-column"
              style={{ minWidth: 0, width: "50%" }}
            >
              <div
                className="text-center py-2"
                style={{
                  background: "#c6edec",
                  borderBottom: "2px solid #198754",
                }}
              >
                <h5 className="mb-0 text-success">
                  <i className="bi bi-gift me-2"></i>Sản phẩm tặng kèm
                </h5>
              </div>
              <div className="flex-grow-1 overflow-auto px-2 pt-2">
                {selectedProduct && giftProducts.length > 0 ? (
                  <div>
                    <div className="row row-cols-2 row-cols-xl-4 g-2">
                      {giftProducts
                        .filter((gift) => (stockMap[gift.MaSP] ?? 1) > 0)
                        .map((gift) => (
                          <div className="col" key={gift.MaSP}>
                            <div
                              className={`card h-100 shadow-sm border-info`}
                              style={{
                                cursor:
                                  mainProductCountInCart > 0 &&
                                    giftCountForMainProduct <
                                    mainProductCountInCart
                                    ? "pointer"
                                    : "not-allowed",
                                opacity:
                                  mainProductCountInCart > 0 &&
                                    giftCountForMainProduct <
                                    mainProductCountInCart
                                    ? 1
                                    : 0.5,
                              }}
                              onClick={() =>
                                mainProductCountInCart > 0 &&
                                giftCountForMainProduct <
                                mainProductCountInCart &&
                                handleGiftClick(gift)
                              }
                              title={
                                mainProductCountInCart === 0
                                  ? "Hãy thêm sản phẩm khuyến mãi vào giỏ trước"
                                  : giftCountForMainProduct >=
                                    mainProductCountInCart
                                    ? "Bạn đã chọn đủ số lượng bánh tặng kèm cho sản phẩm này"
                                    : "Thêm bánh tặng vào giỏ (0đ)"
                              }
                            >
                              <div className="card-body d-flex flex-column justify-content-between p-2">
                                <div>
                                  <b className="text-dark">
                                    {gift.Ten_SP || gift.TenSP}
                                  </b>
                                  <div style={{ fontSize: 13, color: "#888" }}>
                                    Giá:{" "}
                                    <span className="text-danger">
                                      {gift.DonGia?.toLocaleString()}₫
                                    </span>
                                    {gift.SoLuong_UD && (
                                      <span
                                        style={{
                                          marginLeft: 10,
                                          color: "#0d6efd",
                                        }}
                                      >
                                        SL: {gift.SoLuong_UD}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                    {mainProductCountInCart === 0 && (
                      <div className="alert alert-warning text-center mt-3 py-2">
                        Hãy thêm sản phẩm khuyến mãi vào giỏ trước khi chọn bánh
                        tặng kèm
                      </div>
                    )}
                    {mainProductCountInCart > 0 &&
                      giftCountForMainProduct >= mainProductCountInCart && (
                        <div className="alert alert-info text-center mt-3 py-2">
                          Bạn đã chọn đủ số lượng bánh tặng kèm cho sản phẩm này
                        </div>
                      )}
                  </div>
                ) : (
                  <div className="alert alert-secondary text-center mt-3">
                    Chọn sản phẩm để xem tặng kèm
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* PHẦN 2: Giỏ hàng giữ nguyên */}
        <div
          className="col-12 col-lg-4 bg-white shadow-sm d-flex flex-column"
          style={{ height: "100%", minWidth: 320 }}
        >
          <div
            className="text-center py-2"
            style={{ background: "#fffbe7", borderBottom: "2px solid #ffc107" }}
          >
            <h5 className="mb-0 text-warning">
              <i className="bi bi-cart4 me-2"></i>Giỏ hàng
            </h5>
          </div>
          <div className="flex-grow-1 overflow-auto px-3 pt-3">
            {orderItems.length === 0 ? (
              <div className="alert alert-secondary text-center">
                Chưa có sản phẩm
              </div>
            ) : (
              <ul className="list-group mb-3">
                {/* Gom nhóm sản phẩm khuyến mãi và gift theo sản phẩm chính */}
                {orderItems
                  .filter((item) => item.DonGia !== 0)
                  .map((item, idx) => {
                    const relatedGifts = orderItems.filter(
                      (gift) =>
                        gift.DonGia === 0 && gift.selectedMainSP === item.MaSP
                    );
                    return (
                      <React.Fragment key={item.MaSP + "-" + idx}>
                        <li
                          className="list-group-item d-flex justify-content-between align-items-center shadow-sm mb-2 rounded"
                          style={{ position: "relative", zIndex: 2 }}
                        >
                          <div>
                            <b>{item.Ten_SP || item.TenSP}</b>
                            <div style={{ fontSize: 13, color: "#888" }}>
                              {item.DonGia?.toLocaleString()}₫ x {item.quantity}
                            </div>
                          </div>
                          <div>
                            <button
                              className="btn btn-outline-danger btn-sm me-1"
                              onClick={() => handleRemoveFromOrder(item.MaSP)}
                              title="Giảm"
                            >
                              <i className="bi bi-dash-lg"></i>
                            </button>
                            <button
                              className="btn btn-outline-success btn-sm"
                              onClick={() => handleAddToOrder(item)}
                              title="Tăng"
                            >
                              <i className="bi bi-plus-lg"></i>
                            </button>
                          </div>
                        </li>
                        {relatedGifts.map((gift, gidx) => (
                          <li
                            key={gift.MaSP + "-" + gidx}
                            className="list-group-item d-flex align-items-center justify-content-between mb-2 ms-4 border border-success border-2 rounded position-relative"
                            style={{
                              background: "#f6fff6",
                              fontSize: 13,
                              color: "#198754",
                              borderLeft: "4px solid #198754",
                              marginLeft: 32,
                              minHeight: 38,
                              paddingLeft: 36,
                              zIndex: 1,
                            }}
                          >
                            <span
                              style={{
                                position: "absolute",
                                left: -28,
                                top: 0,
                                height: "100%",
                                width: 28,
                                display: "flex",
                                alignItems: "flex-start",
                                pointerEvents: "none",
                              }}
                            >
                              <svg
                                width="28"
                                height="38"
                                style={{ display: "block" }}
                              >
                                <polyline
                                  points="0,0 0,38 28,38"
                                  style={{
                                    fill: "none",
                                    stroke: "#198754",
                                    strokeWidth: 2,
                                  }}
                                />
                              </svg>
                            </span>
                            <span>
                              <b className="me-2">
                                {gift.Ten_SP || gift.TenSP}
                              </b>
                              <span>(Tặng kèm, SL: {gift.quantity})</span>
                            </span>
                            <span>
                              <button
                                className="btn btn-outline-danger btn-sm me-1"
                                onClick={() => handleRemoveGiftFromOrder(gift)}
                                title="Giảm"
                              >
                                <i className="bi bi-dash-lg"></i>
                              </button>
                              <button
                                className="btn btn-outline-success btn-sm"
                                onClick={() => handleAddGiftFromOrder(gift)}
                                title="Tăng"
                              >
                                <i className="bi bi-plus-lg"></i>
                              </button>
                            </span>
                          </li>
                        ))}
                      </React.Fragment>
                    );
                  })}
              </ul>
            )}
          </div>
          <div className="border-top p-3">
            {/* Phần nhập/thông tin khách hàng */}
            <div className="mb-3">
              <label htmlFor="customerPhone" className="form-label">
                SĐT Khách Hàng
              </label>
              <div className="input-group">
                <input
                  type="tel"
                  className="form-control"
                  id="customerPhone"
                  value={customerPhone}
                  onChange={handlePhoneInputChange}
                  placeholder="Nhập SĐT"
                  disabled={customerLoading}
                />
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={handleSearchCustomer}
                  disabled={customerLoading}
                >
                  {customerLoading ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    <i className="bi bi-search"></i>
                  )}
                </button>
              </div>
              {customerInfo && (
                <div className="mt-2 alert alert-success py-2">
                  KH: <b>{customerInfo.TenKH}</b> - Điểm: {customerInfo.DiemTichLuy}
                  <button
                    className="btn btn-sm btn-link text-danger float-end"
                    onClick={() => {
                      setCustomerInfo(null);
                      setCustomerPhone("");
                      localStorage.removeItem("currentCustomerInfo");
                      setShowNewCustomerForm(false);
                    }}
                    title="Xóa thông tin KH"
                  >
                    <i className="bi bi-x-circle"></i>
                  </button>
                </div>
              )}
              {showNewCustomerForm && !customerInfo && (
                <form onSubmit={handleCreateNewCustomer} className="mt-3 p-3 border rounded bg-light">
                  <h5>Thêm khách hàng mới</h5>
                  <div className="mb-2">
                    <label htmlFor="newCustomerName" className="form-label">
                      Tên Khách Hàng <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="newCustomerName"
                      value={newCustomerName}
                      onChange={(e) => setNewCustomerName(e.target.value)}
                      required
                      disabled={customerLoading}
                    />
                  </div>
                  <div className="mb-2">
                    <label htmlFor="newCustomerAddress" className="form-label">
                      Địa Chỉ
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="newCustomerAddress"
                      value={newCustomerAddress}
                      onChange={(e) => setNewCustomerAddress(e.target.value)}
                      disabled={customerLoading}
                    />
                  </div>
                  <div className="mb-2">
                    <label htmlFor="newCustomerTaxCode" className="form-label">
                      Mã Số Thuế
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="newCustomerTaxCode"
                      value={newCustomerTaxCode}
                      onChange={(e) => setNewCustomerTaxCode(e.target.value)}
                      disabled={customerLoading}
                    />
                  </div>
                  <div className="d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary me-2"
                      onClick={() => setShowNewCustomerForm(false)}
                      disabled={customerLoading}
                    >
                      Hủy
                    </button>
                    <button type="submit" className="btn btn-sm btn-primary" disabled={customerLoading}>
                      {customerLoading ? "Đang lưu..." : "Lưu Khách Hàng"}
                    </button>
                  </div>
                </form>
              )}
            </div>
            {/* End Customer Info Section */}
            <div className="mb-3 text-end">
              <b className="fs-5 text-success">
                Tổng cộng: {subtotal.toLocaleString()}₫
              </b>
            </div>
            <button
              className="btn btn-primary w-100 py-2 fs-5"
              onClick={handleCheckout}
              disabled={orderItems.length === 0}
            >
              <i className="bi bi-credit-card-2-front me-2"></i>Thanh toán
            </button>
          </div>
        </div>
      </div>

      {/* Thêm Bootstrap Icons CDN */}
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css"
      />
      <style>{`
        .btn.active, .btn:active, .btn:focus {
          background: #e7f1ff !important;
          color: #0d6efd !important;
        }
        .list-group-item-action:hover {
          background: #f0f8ff !important;
        }
        .card:hover {
          box-shadow: 0 0 12px #0d6efd33 !important;
          border-color: #0d6efd !important;
        }
        @media (max-width: 991.98px) {
          .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-8 {
            min-width: unset !important;
          }
        }
        /* Ngăn bôi đen khi click vào sản phẩm */
        .card, .card * {
          user-select: none !important;
          -webkit-user-select: none !important;
          -moz-user-select: none !important;
          -ms-user-select: none !important;
        }
        
        /* Side menu animations */
        .menu-open {
          transform: translateX(0) !important;
        }
        .menu-closed {
          transform: translateX(100%) !important;
        }
      `}</style>
    </div>
  );
}

export default PromotionPage;
